module.exports = __webpack_public_path__ + "img/cd_1021.6e02c4fa.jpg";